import { createSlice } from '@reduxjs/toolkit';
import { ChatMessage, ChatPendingConfirmation, ChatQuota } from 'modules/chat/domain/interfaces';
import { createClearChatHistoryReducer, createLoadChatHistoryReducer, createSendChatMessageReducer } from './reducers';

export interface ChatState {
  messages: ChatMessage[];
  isSending: boolean;
  isClearing: boolean;
  isLoadingHistory: boolean;
  error?: string;
  quota?: ChatQuota;
  pendingConfirmation?: ChatPendingConfirmation | null;
}

const initialState: ChatState = {
  messages: [],
  isSending: false,
  isClearing: false,
  isLoadingHistory: false,
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    resetChatError(state) {
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    createSendChatMessageReducer(builder);
    createLoadChatHistoryReducer(builder);
    createClearChatHistoryReducer(builder);
  },
});

export const { resetChatError } = chatSlice.actions;

export default chatSlice.reducer;
